import { DataModel } from "../../base/DataModel.js";
import { ListDataModel } from "../../base/ListDataModel.js";
import type {
  ContainerVolumeRelationData,
  ContainerVolumeRelationFormValues,
} from "./types.js";

export class ContainerVolumeRelation extends DataModel<ContainerVolumeRelationData> {
  public readonly type?: "directory" | "volume";
  public readonly volume?: string;
  public readonly projectDirectory?: string;
  public readonly containerPath?: string;

  public constructor(data: ContainerVolumeRelationData) {
    super(data);
    const [prefix, suffix] = data.split(":");
    const type =
      prefix && prefix.startsWith("/") && suffix ? "directory" : "volume";
    this.type = type;
    this.volume = type === "volume" && suffix ? prefix : undefined;
    this.projectDirectory = type === "directory" && suffix ? prefix : "/";
    this.containerPath = suffix ?? prefix;
  }

  public fromFormValues(
    values: ContainerVolumeRelationFormValues,
  ): ContainerVolumeRelation {
    return new ContainerVolumeRelation(
      values.type === "volume"
        ? `${values.volume}:${values.containerPath}`
        : `${values.projectDirectory}:${values.containerPath}`,
    );
  }
}

export class ContainerVolumeRelationList extends ListDataModel<ContainerVolumeRelation> {
  public constructor(relations: ContainerVolumeRelationData[]) {
    super(
      relations.map((r) => new ContainerVolumeRelation(r)),
      relations.length,
    );
  }

  public toStringArray(): string[] {
    return this.items.map((v) => v.data);
  }
}
